import { gql } from '@apollo/client';

export const fetchLinkedEntitlementsForTable = gql`
  query fetchLinkedEntitlementsForTablePPC(
    $id: String!
    $searchLinkedEntitlementParams: SearchLinkedEntitlementParams!
    $transactionAccountId: String
  ) {
    entitlementDetails(id: $id, filters: { transactionAccountId: $transactionAccountId }) {
      id
      transactionAccountId
      linkedEntitlements(searchLinkedEntitlementParams: $searchLinkedEntitlementParams) {
        entitlementId
        productId
        entitlementNumber
        productName
        billingCycle
        billingFrequency
        latestPeriodEndDate
        offeringId
        subscriptionId
        billingStatus
        isApp
        transactionAccountId
        billingGroupId
        edition
        isSandbox
        parentSen
        logoId
        userTier
        offering {
          pricingType
        }
        relatesFromEntitlements {
          entitlementId
          relationshipType
        }
      }
    }
  }
`;
